import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import printJS from 'print-js-updated';
import { Utilities } from 'src/app/models/utilities';
import { AppCoreService } from 'src/app/services/app-core.service';
import { ManifestService } from 'src/app/services/operations/manifest.service';

@Component({
    selector: 'app-bag',
    templateUrl: './bag-print.component.html',
    styleUrls: ['./bag-print.component.scss']
})

export class BagPrintComponent implements OnInit, AfterViewInit {
    bagForm: FormGroup;
    isFormSubmitted = false;
    differenceInValue = 5;
    isGreaterDifference = false;
    @Input() public manifestNumber: number;
    useEnterKey: any;

    constructor(
        private appCoreService: AppCoreService,
        public activeModal: NgbActiveModal,
        private formBuilder: FormBuilder,
        private ngxLoaderService: NgxUiLoaderService,
        private manifestsService: ManifestService,
        private utilities: Utilities,
    ) { }

    ngOnInit() {
        this.bagForm = this.formBuilder.group({
            txtFromNo: ['', Validators.compose([Validators.required])],
            txtToNo: [''],
            txtRemark: ['', Validators.compose([Validators.maxLength(100)])]
        });

        const userData = this.appCoreService.GetUserData();
        this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
    }

    ngAfterViewInit() {
        this.useEnterKey ? this.utilities.focusFirstElement(this.bagForm) : null;
    }

    onSaveClick() {
        this.isFormSubmitted = true;
        if (this.isGreaterDifference) {
            this.validateRange();
            return;
        }
        if (this.bagForm.valid) {
            const reqObj = {
                manifestNumber: this.manifestNumber,
                fromno: this.bagForm.get('txtFromNo')?.value,
                tono: this.bagForm.get('txtToNo')?.value,
                remark: this.bagForm.get('txtRemark')?.value,
                type: 'bag'
            }
            this.ngxLoaderService.start();
            try {
                this.manifestsService.GeneratePDF(reqObj).subscribe((res) => {
                    if (res && res.success) {
                        this.ngxLoaderService.stop();
                        if (res?.data?.err_msg) {
                            this.activeModal.close('Pdf is generated');
                            return this.appCoreService.showMessage(res?.data?.err_msg, 'Error', 'error');
                        }
                        this.activeModal.close('Pdf is generated');
                        let pdfString = JSON.parse(res.data);
                        printJS({ printable: pdfString, type: 'pdf', base64: true, showModal: true });
                    }

                });

            } catch (err) {
                this.ngxLoaderService.stop();
            }
        }
    }

    validateRange() {
        const fromno = parseInt(this.bagForm.get('txtFromNo')?.value);
        const tono = parseInt(this.bagForm.get('txtToNo')?.value);
        const maxvalue = fromno + this.differenceInValue;

        if (tono > maxvalue) {
            this.appCoreService.showMessage('Maximum Value exceeded. ', 'Info', 'info');
            this.isGreaterDifference = true;
            return;
        }
        else if (tono < fromno) {
            this.appCoreService.showMessage('Value of To is Smaller than From.', 'Info', 'info');
            this.isGreaterDifference = true;
            return;
        }
        this.isGreaterDifference = false;
    }

    resetForm() {
        this.bagForm.reset();
        this.isFormSubmitted = false;
    }
}
